// extracted by mini-css-extract-plugin
export var container = "_h5-0";
export var content = "_h5-3";
export var customerTitle = "_h5-4";
export var empty = "_h5-5";
export var gray = "_h5-6";
export var header = "_h5-7";
export var info = "_h5-8";
export var loading = "_h5-2";
export var loadingCard = "_h5-9";
export var oneLine = "_h5-a";
export var personName = "_h5-e";
export var pillContainer = "_h5-b";
export var selected = "_h5-1";
export var text = "_h5-c";
export var twoLines = "_h5-d";
export var unread = "_h5-f";
export var unreadIndicator = "_h5-g";